import { render, staticRenderFns } from "./HealthHistoryModal.vue?vue&type=template&id=e99d7300"
import script from "./HealthHistoryModal.vue?vue&type=script&lang=js"
export * from "./HealthHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports